<div class="dialog-content">
  <div class="html-content" internalLinkNavigate mat-dialog-content [innerHTML]="data"></div>
  <div mat-dialog-actions class="tw-flex tw-justify-between">
    <button mat-button (click)="closeDialog()">
      {{ 'common.button.cancel' | translate }}
    </button>
  </div>
</div>
